export enum StonlyLinks {
    ERR0="",
    ERR1="",
    ERR2="https://www.youtube.com/watch?v=MyyJFiwKsDE&list=PLYKcQzxZyyrg&index=2&pp=iAQB",
    ERR3="https://www.youtube.com/watch?v=w9VgWOKe0eE&list=PLYKcQzxZyyrg&index=3&pp=iAQB",
    ERR4="https://www.youtube.com/watch?v=lULRJMhTr0o&list=PLYKcQzxZyyrg&index=7&pp=iAQB",
    ERR5="",
    ERR6="",
    ERR7="",
    ERR8="https://www.youtube.com/watch?v=7qTC-WeIA0Q&list=PLYKcQzxZyyrg&index=5&pp=iAQB",
    ERR9="",
    ERR10="",
    ERR11="",
    ERR12="",
    ERR13="https://www.youtube.com/watch?v=0o-c1hBwAaI&list=PLYKcQzxZyyrg&index=8&pp=iAQB",
    ERR14="https://www.youtube.com/watch?v=KaCezN0O1IM&list=PLYKcQzxZyyrg&index=1&pp=iAQB",
    ERR15="https://www.youtube.com/watch?v=_AL2SVM0iQ8&list=PLYKcQzxZyyrg&index=4&pp=iAQB",
    ERR16="",
    ERR17="",
    ERR18="",
    ERR19="",
    ERR20="",
    ERR21="",
    ERR22="",
    ERR23="",
    ERR24="",
    ERR25="",
    ERR26="",
    ERR27="",
    ERR28="",
    ERR29="",
    ERR30="",
    ERR31="",
    ERR32="",
    ERR33="",
    ERR34="",
    ERR35="",
    ERR36="",
    ERR37="",
    ERR38="",
    ERR39="",
    ERR40="",
    ERR41="",
    ERR42="",
    ERR43="",
    ERR44="",
    ERR45="",
    ERR46="",
    ERR47="",
    ERR48="",
    ERR49="",
    ERR50="",
    ERR51="",
    ERR52="",
    ERR53="",
    ERR54="",
    ERR55="",
    ERR56="",
    ERR57="",
    ERR58="",
    ERR59="",
    ERR60="",
    ERR61="",
    ERR62="",
    ERR63="",

    STAT0="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2051192",
    STAT1="https://www.youtube.com/watch?v=nq_0GbIdr2M&list=PLYKcQzxZyyrg&index=6&pp=iAQB",
    STAT2="",
    STAT3="",
    STAT4="",
    STAT5="",
    STAT6="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064285",
    STAT7="",
    STAT8="",
    STAT9="",
    STAT10="https://www.youtube.com/watch?v=Ay3dkizoue4&list=PLYKcQzxZyyrg&index=10&pp=iAQB",
    STAT11="",
    STAT12="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064509",
    STAT13="",
    STAT14="",
    STAT15="",
    STAT16="",
    STAT17="",
    STAT18="",
    STAT19="",
    STAT20="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064601",
    STAT21="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064603",
    STAT22="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064632",
    STAT23="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064638",
    STAT24="",
    STAT25="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064640",
    STAT26="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064641",
    STAT27="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064643",
    STAT28="https://arcticspas-yfxhw.stonly.com/kb/guide/en/error-codes-remedies-2020-custom-series-Vq8PamDRFs/Steps/2050837,2064657",
    STAT29="",
    STAT30="",
    STAT31="",
    STAT32="",
    STAT33="",
    STAT34="",
    STAT35="",
    STAT36="",
    STAT37="",
    STAT38="",
    STAT39="",
    STAT40="",
    STAT41="",
    STAT42="",
    STAT43="",
    STAT44="",
    STAT45="",
    STAT46="",
    STAT47="",
    STAT48="",
    STAT49="",
    STAT50="",
    STAT51="",
    STAT52="",
    STAT53="",
    STAT54="",
    STAT55="",
    STAT56="",
    STAT57="",
    STAT58="",
    STAT59="",
    STAT60="",
    STAT61="",
    STAT62="",
    STAT63="",
}